/**
 * @spec docs/specs/features/staking-position-ui.md#framework-portability-patterns
 * Framework-agnostic route definitions
 *
 * Works with both React Router and Next.js Link.
 * Use these helpers everywhere instead of hardcoded paths.
 */

export const routes = {
  home: () => '/',
  address: (address: string) => `/address/${address}`,
  stake: () => '/stake',
  swap: () => '/swap',
  /** CHIP withdrawal page (CHIP migration). */
  withdraw: () => '/withdraw',
  /** Reserve transparency. Reachable by URL only: not linked from the nav for now. */
  reserves: () => '/reserves',
  /** Lending (Credit Pool) coming-soon page with the interest sign-up form. */
  lending: () => '/lending',
} as const;

// Type helpers for route parameters
export type RouteParams = {
  address: { address: string };
};
